import React from "react";
import { Link } from "react-router-dom";
import "./GlassButton.scss";

const GlassButton = ({
  as = "button",
  to,
  children,
  variant = "primary",
  size = "md",
  icon,
  active = false,
  disabled = false,
  onClick,
  ariaLabel
}) => {
  const cls =
    `btn btn--glass btn--${variant} btn--${size}` +
    (active ? " is-active" : "") +
    (disabled ? " is-disabled" : "");

  if (as === "link" && to) {
    return (
      <Link
        to={to}
        className={cls}
        aria-label={ariaLabel}
        onClick={onClick}
        draggable="false"
      >
        {icon && <span className="btn__icon" aria-hidden="true">{icon}</span>}
        <span className="btn__label">{children}</span>
      </Link>
    );
  }

  return (
    <button
      type="button"
      className={cls}
      onClick={onClick}
      aria-pressed={active ? "true" : "false"}
      aria-label={ariaLabel}
      disabled={disabled}
    >
      {icon && <span className="btn__icon" aria-hidden="true">{icon}</span>}
      <span className="btn__label">{children}</span>
    </button>
  );
};

export default GlassButton;
